import { render, staticRenderFns } from "./TgRadioButton.vue?vue&type=template&id=53d8961d"
import script from "./TgRadioButton.vue?vue&type=script&lang=js"
export * from "./TgRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports